import React, {Component} from 'react'

const Jeyu = {
  flexBox: {
    background: '#333',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  Info: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#444',
    fontSize: 50
  }
}

export default class Conversation extends Component {
  render() {
    return(
      <div style={Jeyu.flexBox}>
       <div style={Jeyu.Info}>官網籌備中<br />可先登入新增自己的英文詞彙喔</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Conversation.js